module.exports = __webpack_public_path__ + "img/instagram.00f565d.svg";